<template>
  <b-modal size="lg" :visible="visible" no-close-on-backdrop no-close-on-esc centered>
    <div slot="modal-header" class="w-100">
      <h5>{{title}}<button type="button" class="close"
                           @click.prevent="closeModal()">
        <span aria-hidden="true">&times;</span></button>
      </h5>
    </div>
    <b-form>
      <div class="container-fluid visit-charge-body">
        <div class="row justify-content-center m-2">
          <div class="alert alert-danger col" role="alert" v-show="errorMessage">
            <div>{{ errorMessage }}</div>
          </div>
        </div>
        <div class="row">
          <div class="col-2">
          </div>
          <div class="col-8">
            <b-form-group id="amountFieldGroup"
                          horizontal
                          :label-cols="4"
                          breakpoint="md"
                          :state="stateForField('amount')"
                          :invalid-feedback="errorForField('amount')"
                          label="Amount"
                          label-for="amountField"
                          label-class="text-right">
              <b-input-group prepend="$">
                <b-form-input id="amountField" v-model="fee.amount"></b-form-input>
              </b-input-group>
            </b-form-group>
            <b-form-group id="descriptionFieldGroup"
                          horizontal
                          :label-cols="4"
                          breakpoint="md"
                          :state="stateForField('description')"
                          :invalid-feedback="errorForField('description')"
                          label="Description"
                          label-for="descriptionField"
                          label-class="text-right">
              <b-form-input id="descriptionField" v-model="fee.description"></b-form-input>
              <div class="pt-1">
                <font-awesome-icon size="sm" class="text-warning mr-2 align-baseline" icon="exclamation-triangle"/> <span class="text-muted align-bottom">This will be visible to the patient.</span>
              </div>
            </b-form-group>
            <b-form-group horizontal
                          :label-cols="4"
                          breakpoint="md"
                          :state="stateForField('coveredItem')"
                          :invalid-feedback="errorForField('coveredItem')"
                          label="Covered Item?"
                          label-class="text-right">
              <b-form-radio-group v-model="fee.coveredItem" class="pt-2" :options="coveredItemOptions" />
            </b-form-group>
          </div>
        </div>
      </div>
    </b-form>
    <div slot="modal-footer" class="w-100">
      <button type="button" class="btn btn-orange float-right" @click.prevent="save()"><font-awesome-icon size="lg" class="mr-2" v-show="isSaving" icon="spinner"  pulse/>Add Fee</button>
      <button type="button" class="btn btn-outline-orange mr-2 float-right" @click.prevent="closeModal()">Close</button>
    </div>
  </b-modal>
</template>

<script>
  import ErrorsMixin from '../mixins/ErrorsMixin.js'

  export default {
    name: 'PatientEstimateAscFeeModal',

    mixins: [ErrorsMixin],

    props: {
      visible: {
        type: Boolean,
        required: true
      },

      title: {
        type: String,
        default: 'Add Estimate Surgery Center Fee'
      }
    },

    data () {
      return {
        fee: {
          description: '',
          amount: '',
          coveredItem: ''
        },
        isSaving: false,
        errorMessage: '',
        coveredItemOptions: [
          { value: true, text: 'Yes' },
          { value: false, text: 'No' }
        ]
      }
    },

    watch: {
      visible (newValue, oldValue) {
        if (newValue) {
          this.clearData()
        }
      }
    },

    methods: {
      clearData () {
        this.clearAllErrors()
        this.fee = {
          description: '',
          amount: '',
          coveredItem: ''
        }
      },

      validate () {
        this.clearAllErrors()
        const amountValue = parseFloat(this.fee.amount)
        if (!amountValue) {
          this.addErrorForField('amount', 'An amount is required.')
        }

        if (amountValue < 0) {
          this.addErrorForField('amount', 'Amount must be greater then zero.')
        }

        if (this.fee.coveredItem !== true && this.fee.coveredItem !== false) {
          this.addErrorForField('coveredItem', 'You must choose Yes or No')
        }

        if (!this.fee.description) {
          this.addErrorForField('description', 'A description is required.')
        }

        if (this.fee.description.length > 255) {
          this.addErrorForField('description', 'The description must be less then 255 characters')
        }

        return !this.hasErrors()
      },

      save () {

        if (this.isSaving) {
          return
        }

        if (!this.validate()) {
          return
        }

        this.fee.amount = parseFloat(this.fee.amount)

        this.$emit('addFee', this.fee)
      },

      closeModal () {
        this.$emit('update:visible', false)
      }
    }
  }
</script>

<style scoped>
.visit-charge-body {
  font-size: 16px;
}

.current-charge .fa-trash-alt {
  cursor: pointer;
}

.current-charge .fa-trash-alt:HOVER {
  color: rgb(255, 70, 0);
}

</style>
